import React, { FC } from 'react';

import {
    Navigate,
    useLocation,
} from 'react-router-dom';
import AccessDenied from '../pages/AccessDenied/AccessDenied';
import { useAppSelector } from '../store/hooks';
import { PermissionsEnum } from '../utils/auth.types';

interface IRequiredRole {
    requiredRole?: PermissionsEnum;
}

/**
 * This is used as protected route. Used to protect the routes from unauthorized access.
 */
const PrivateRoute: FC<React.PropsWithChildren<IRequiredRole>> = ({ requiredRole = '', children }) => {
    const location = useLocation();
    const { isLoggedIn, permissions, user } = useAppSelector(state => state.auth);
    // If user is not logged in, redirect the user to login page.
    if (!isLoggedIn) {        
        return <Navigate to='/signin' state={{ path: location.pathname }}/>
    }

    // If user is logged in but doesn't have permission to access the route.
    if (requiredRole) {
        const userHasRequiredRole = isLoggedIn && permissions?.includes(requiredRole) ? true : false;
        if (isLoggedIn && !userHasRequiredRole) {
            return <AccessDenied />;
        }
    }
    
    if (user.accounts.length <= 0) {
        return <Navigate to='/account/create-basic-info' />
    }

    if (user?.isDefaultPassword) {
        return <Navigate to='/reset-password' />
    }

    return <>{ children }</>;
}

export default PrivateRoute;